module.exports = __webpack_public_path__ + "img/cloth_g3_item-11.bfe98931.svg";